import { get, put } from "./http.service";

const requestOptions = { preserveHttpError: true, suppressErrorToast: true };

const NearbyRouteService = {
  getPropertyAssociations: (propertyType, propertyId, language) =>
    get(`nearbyRoute/properties/${propertyType}/${propertyId}`, {
      ...requestOptions,
      params: { language },
    }),
  search: query => get("nearbyRoute/search", { ...requestOptions, params: query }),
  savePropertyAssociations: (propertyType, propertyId, body) =>
    put(`nearbyRoute/properties/${propertyType}/${propertyId}`, body, requestOptions),
};

export default NearbyRouteService;
